import { generateClient } from 'aws-amplify/api';
import { deleteTimeSheet } from "../graphql/mutations";

const client = generateClient();

export default async ({ id }) => {
    const {
        data: { deleteTimeSheet: deletedTimesheet },
    } = await client.graphql({
        query: deleteTimeSheet,
        variables: {
            input: {
                id
            },
        },
    });
    return deletedTimesheet;
};